import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {
    width: "520px",
    maxWidth: "520px",
  },
  confirm: {
    backgroundColor: "#F79009",
    height: "40px",
    padding: "8px 20px",
  },
  cancel: {
    color: "#232325",
    "&:hover": {
      color: "#232325",
    },
  },
  text: {
    fontFamily: "Inter",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "24px",
  },
  info: {
    color: "#232325",
    marginBottom: "8px",
  },
  warning: {
    color: "#F79009",
    fontStyle: "italic",
  },
}));

export default styles;
